export enum Role {
    SuperAdmin = 1,
    CompanyAdmin = 2,
    User = 3,
  }